module.exports = __webpack_public_path__ + "static/img/notfind.fc45134.jpg";